// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"38ada745","502":"8c292910","914":"1fe3233c"}[chunkId] + ".chunk.css";
};